/**
 * Capability linkage templates (Feature 71). Platform administrators only.
 *
 * A save is judged whole: a refused one answers 422 with `reason`
 * `graph_invalid` and every problem in `details.problems`, each located on
 * a step, a `from→to` link, or `graph`; a taken key or a template still in
 * use answers 409.
 */
import { apiDelete, apiGet, apiPost, apiPut } from '../client.js';
import type { LinkageTemplate, LinkageTemplateBody } from '../types.js';

const BASE = '/api/v1/admin/linkage-templates';

export function listLinkageTemplates(): Promise<LinkageTemplate[]> {
  return apiGet<LinkageTemplate[]>(BASE);
}

export function getLinkageTemplate(key: string): Promise<LinkageTemplate> {
  return apiGet<LinkageTemplate>(`${BASE}/${encodeURIComponent(key)}`);
}

export function createLinkageTemplate(body: LinkageTemplateBody): Promise<LinkageTemplate> {
  return apiPost<LinkageTemplate>(BASE, body);
}

/** The whole template replaced; the body's key must be the path's. */
export function replaceLinkageTemplate(
  key: string,
  body: LinkageTemplateBody,
): Promise<LinkageTemplate> {
  return apiPut<LinkageTemplate>(`${BASE}/${encodeURIComponent(key)}`, body);
}

export function deleteLinkageTemplate(key: string): Promise<void> {
  return apiDelete<void>(`${BASE}/${encodeURIComponent(key)}`);
}
